import Link from 'next/link'
import { Card, CardContent } from '@/components/ui/card'
import { Code2, Brain, Server, FileText, ShoppingBag, Database, Workflow, Sparkles, LucideIcon } from 'lucide-react'

interface Category {
  title: string
  subtitle: string
  icon: LucideIcon
  href: string
  isCustom?: boolean
}

const categories: Category[] = [
  { title: '웹/앱 개발', subtitle: '프로덕트/서비스', icon: Code2, href: '/freelancer/projects?feild=웹 개발' },
  { title: 'AI · 데이터', subtitle: '모델/분석/솔루션', icon: Brain, href: '/freelancer/projects?feild=인공지능(AI)/데이터' },
  { title: '인프라 · DevOps', subtitle: '클라우드/운영', icon: Server, href: '/freelancer/projects?feild=인프라/클라우드/보안' },
  { title: '서비스 기획', subtitle: 'RFP/요구사항', icon: FileText, href: '/freelancer/projects?feild=기획/PM' },
  { title: '커머스 구축', subtitle: '쇼핑몰/결제', icon: ShoppingBag, href: '/freelancer/projects?feild=소프트웨어/솔루션' },
  { title: '데이터 엔지니어링', subtitle: 'ETL/파이프라인', icon: Database, href: '/freelancer/projects?feild=인공지능(AI)/데이터' },
  { title: '자동화', subtitle: 'CI·CD', icon: Workflow, href: '/freelancer/projects?feild=인프라/클라우드/보안' },
  { title: '맞춤 의뢰', subtitle: '상담 후 연결', icon: Sparkles, href: '/freelancer/projects', isCustom: true },
]

interface ExploreCategoriesProps {
  isVisible: boolean
}

export default function ExploreCategories({ isVisible }: ExploreCategoriesProps) {
  return (
    <section
      className={`w-full bg-white px-4 py-16 sm:px-6 md:py-20 lg:px-8 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
    >
      <div className="mx-auto max-w-6xl">
        <div className="mb-12 text-center">
          <h2 className="mb-4 text-3xl font-bold text-gray-900 md:text-4xl">
            프로젝트 카테고리
          </h2>
          <p className="mx-auto max-w-2xl text-base text-gray-600 md:text-lg">
            원하는 분야를 빠르게 찾아보세요
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((category, index) => {
            const Icon = category.icon
            return (
              <Link
                key={category.title}
                href={category.href}
                className={`group block transition-all duration-300 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-500/25 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`}
                style={{
                  transitionDelay: isVisible ? `${index * 50}ms` : '0ms',
                }}
              >
                <Card className="h-full rounded-2xl border-2 border-gray-200 bg-white shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-blue-200 hover:shadow-md active:translate-y-0 active:border-blue-300">
                  <CardContent className="h-full min-h-[100px] sm:min-h-[120px] flex flex-col justify-between gap-3 p-4 sm:p-5">
                    {/* 상단: 텍스트 영역 */}
                    <div className="min-w-0 flex-1">
                      <div className="text-sm sm:text-base font-bold leading-tight text-gray-900 mb-1">
                        {category.title}
                      </div>
                      <div className="text-xs sm:text-sm font-medium leading-relaxed text-gray-600">
                        {category.subtitle}
                      </div>
                    </div>

                    {/* 하단: 아이콘 */}
                    <div className="flex justify-end">
                      <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-50 transition-colors group-hover:bg-blue-100">
                        <Icon className="h-5 w-5 text-blue-600 sm:h-6 sm:w-6" strokeWidth={2.5} />
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            )
          })}
        </div>
      </div>
    </section>
  )
}

